import React, { Fragment, useCallback, useEffect } from "react";
import logo from "../../Assets/img/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";

export default function Header() {
  const { pathname } = useLocation();
  const { isAuth } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    window.$(window).scroll(function () {
      if (window.$(this).scrollTop() > 100) {
        window.$("#header").addClass("header-scrolled");
      } else {
        window.$("#header").removeClass("header-scrolled");
      }
    });

    window.$(".nav-menu").superfish({
      animation: {
        opacity: "show",
      },
      speed: 400,
    });

    if (window.$("#nav-menu-container").length) {
      window
        .$("#mobile-nav")
        .find(".menu-has-children")
        .prepend('<i className="lnr lnr-chevron-down"></i>');

      window.$(document).on("click", ".menu-has-children i", function (e) {
        console.log("clicked-2");
        window.$(this).next().toggleClass("menu-item-active");
        window.$(this).nextAll("ul").eq(0).slideToggle();
        window.$(this).toggleClass("lnr-chevron-up lnr-chevron-down");
      });

      window
        .$(document)
        .not("#mobile-nav-toggle")
        .click(function (e) {
          var container = window.$("#mobile-nav, #mobile-nav-toggle");
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            if (window.$("body").hasClass("mobile-nav-active")) {
              window.$("body").removeClass("mobile-nav-active");
              window
                .$("#mobile-nav-toggle i")
                .toggleClass("lnr-cross lnr-menu");
              window.$("#mobile-body-overly").fadeOut();
            }
          }
        });
    } else if (window.$("#mobile-nav, #mobile-nav-toggle").length) {
      window.$("#mobile-nav, #mobile-nav-toggle").hide();
    }
  }, []);

  const onMenuClick = useCallback(() => {
    window.$("body").toggleClass("mobile-nav-active");
    window.$("#mobile-nav-toggle i").toggleClass("lnr-cross lnr-menu");
    window.$("#mobile-body-overly").toggle();
  }, []);

  useEffect(() => {
    window.$("html, body").scrollTop(0);
    if (window.$("body").hasClass("mobile-nav-active")) {
      onMenuClick();
    }
  }, [pathname, onMenuClick]);

  return (
    <Fragment>
      <header id="header">
        <div className="container">
          <div className="row align-items-center justify-content-between d-flex">
            <div id="logo">
              <Link to="/">
                <img src={logo} alt="" title="" />
              </Link>
            </div>
            {pathname !== "/create-profile" && (
              <nav id="nav-menu-container">
                <ul className="nav-menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="about">About Us</Link>
                  </li>
                  <li className="menu-active">
                    <Link to="jobs" state={{ time: new Date() }}>
                      Jobs
                    </Link>
                  </li>
                  <li>
                    <Link to="workshop">Workshop</Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.thepridecircle.com/rise2025/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      RISE Jobs 2025
                    </Link>
                  </li>
                  <li>
                    <Link to="contact">Contact Us</Link>
                  </li>
                  {!isAuth ? (
                    <>
                      <li>
                        <Link className="ticker-btn text-white" to="create-profile">
                          <i className="fa fa-upload" /> Upload your CV
                        </Link>
                      </li>
                      <li>
                        <Link
                          state={{ login: true }}
                          className="ticker-btn text-white"
                          to="login"
                        >
                          Login
                        </Link>
                      </li>
                    </>
                  ) : (
                    <li>
                      <Link className="ticker-btn text-white" to="/resume">
                        <i className="fa fa-user" /> My Account
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            )}
            {/* #nav-menu-container */}
          </div>
        </div>
      </header>
      <nav id="mobile-nav">
        <ul className="" style={{ touchAction: "pan-y" }} id="">
          <li>
            <Link to="/about">About Us</Link>
          </li>
          <li className="menu-active">
            <Link to="/jobs">Jobs</Link>
          </li>
          <li>
            <Link to="/about">Workshop</Link>
          </li>
          <li>
            <Link
              href="https://www.thepridecircle.com/rise2024/"
              target="_blank"
              rel="noreferrer"
            >
              RISE Job Fair
            </Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          <li>
            <Link className="ticker-btn" to="/create-profile">
              <i className="fa fa-upload"></i> Upload your CV
            </Link>
          </li>
          <li>
            <Link className="ticker-btn" to="/login">
              Login
            </Link>
          </li>
        </ul>
      </nav>
      <div id="mobile-body-overly"></div>
      <button type="button" id="mobile-nav-toggle" onClick={onMenuClick}>
        <i className="lnr lnr-menu"></i>
      </button>
    </Fragment>
  );
}
